import { render, staticRenderFns } from "./OffscreenCanvas.vue?vue&type=template&id=47d118e0&"
import script from "./OffscreenCanvas.vue?vue&type=script&lang=js&"
export * from "./OffscreenCanvas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports